module.exports = import("https://cdn.jsdelivr.net/gh/contentauth/dash.js@3ecdd3b/samples/c2pa/C2paPlayer/main.js");;